/**
 * 状态类：status { success、error、warn }
 * 弹窗类：dialog { toast、alert、confirm }
 * 表单类：from { placeholder、label }
 * 表格类：table { }
 *
 * 接口请求类：request
 * 接口响应类：responce
 *
 * 页面模块类：
 *
 */

// 使用 {{$t("purchase.periods")}}  //第*期

// 状态
const state = {
  preheatIng: "预热中",
  purchaseIng: "抢购中",
  process: "助力中",
  over: "已结束",
  finish: "已完成",
  noData: "暂无数据",
};

//抢购区和个人抢购记录页上方的subheader
const subheader = {
  pricePromise: "价格担保，绝不破发",
  vipPrice: "VIP返利，价格优惠",
  protection: "独家法币本位保价",
  pricePromiseVal: "[*]天保价，绝不破发",
  rewards: "[*]%收益，承诺保价",
  vipDis: "VIP折扣，抢到赚到",
  zlz: "助力中",
};

// 抢购区
const purchase = {
  periods: "第[*]期",
  timesSheaves: "第[*]轮",
  supportPic: "[*]天保价，绝不破发",
  earnings: "[*]%收益，承诺保价",
  vipDiscount: "VIP折扣，抢到赚到",
  limit: "本轮额度",
  timeLimit: "限时价格",
  schedule: "当前进度",
  finishHalf: "已完成[*]%",
  subscriptionNum: "抢购数量",
  vipText: "（VIP[*]）享购买（[**] [***] [****]折）优惠", //（VIP6）享购买（2000COINS 5折）优惠
  supportType:"保价方式：在保价期内，BiKing将以最低保价价格在二级市场挂入买单，用户可选择是否在保价期内卖出，保价期结束后，相关最低保价买单将被撤销。",
  beAbouttoAlipay: "即将开抢",
  atOnceAlipay: "立即抢购",
  atOnceAlipayNew: "立即助力",
  atOnceAlipayed: "您已抢购，请关注下一轮",
  atOnceAlipayedOver: "您已抢购，不能再次抢购",
  atOnceAlipayedNew: "您已助力，请关注下一轮",
  atOnceAlipayedNewOver: "您已助力，不能再次参与",
  website: "网站",
  whitePaper: "白皮书",
  foreshow: "抢购预告",
  startToUp: "开始抢购",
  startToUpNew: "开始助力",
  distanceStartToUp: "距离开抢",
  num: "目前累计（[*]） 人抢到 （[**] BAT）",
  bannerText: "[*] 抢到[**]额度",
  bannerTextNew: "[*] 助力[**]额度",
  nextProject: "您的额度已抢完，请关注下一个项目",
  timesText: "本轮全部抢完，下一轮[*]月[**]日 [***]：[****]：[*****] 准时开抢",
  times: "[*] 日 [**] 时 [***] 分 [****] 秒",
  viewDetail: "查看详情",
  completePawd: "完成账户交易密码设置",
  sureCoins: "确保持仓大于[*] [**]（最低购买量）",
  sureBalance: "确保账户中[*]的余额大于[**]",
  set: "去设置",
  available: "可抢额度",
  holding: "账户持仓",
  startSoon: "抢购即将开始",
  startSoonNew: "助力即将开始",
  projectSupp: "项目额度",
  projectSuppNew: "助力上限",
  successBuy: "成功抢购",
  successBuyNew: "成功助力",
  projectLimit: "距项目开始还剩",
  subscription: "已成功抢购",
  subscriptionNew: "已成功助力",
  projectGoal: "此项目抢购总额度",
  projectGoalNew: "此项目助力额度",
  goalFunds: "目前已完成抢购",
  goalFundsNew: "实际助力达到目标",
};

//抢购条件

const purchaseCondition = {
  q: " 且 ",
  h: " 或 ",
  cztj: "确保充值数量",
  wqyh: "限未参加相关往期活动的用户",
  vipdj: "限VIP[*]及以上VIP等级的用户",
  condition: "抢购条件",
  conditionNew: "助力条件",
  nameverify1: "完成中国大陆的KYC认证",
  nameverify2: "完成中国大陆以外KYC认证",
  nameverify3: "完成BiKing KYC认证",
  login: "请登录",
  maxBuyin: "最大买入",
  verify: "去KYC验证",
  affirm: "确保持仓度大于[*]",
  myPosition: "我的持仓",
  AmountOfAscension: "抢购额度",
  AmountOfAscensionNew: "助力额度",
  AmountOfAscensionText: "第一轮开始前7日[*]日均持仓量越大，您的抢购额度越大",
  AmountOfAscensionTime: "我的前7日[*]日均持仓",
  discount: "抢购打折",
  vip_discount: "助力打折",
  discountText: "VIP等级越高，抢购价格越低",
  upgrade: "去升级",
  vipUpgrade: "我的VIP",
  zled: "助力额度",
  wdzl: "我的助力",
  zlxm: "助力项目",
  mlzl: "每轮助力",
  zlmx: "助力明细",
  ccff: "初次发放",
  qgmx: "抢购明细",

  fjtj: "附加条件",
  guoji: "国籍",
  noJoin: "不支持参加",
  wancheng: "完成",
  pinggu: "《数字货币投资风险测评表》",
  cyhd: "参与活动",
};

// 历史项目
const historyProject = {
  rushLimit: "抢购额度",
  averagePic: "平均价格",
  averageNum: "抢购人数",
};

// 支付
const alipay = {
  alipaynum: "抢购数量",
  alipaynumNew: "助力额度",
  ShouldPay: "应支付",
  VipDiscounts: "VIP折扣",
  VipWin: "win会员折扣",
  willOpen: "即将开放",
  actualPayment: "实际支付",
  actualPaymentNew: "本轮助力",
  importPassword: "请输入交易密码",
  forGetPassword: "忘记交易密码？",
  promptlyAlipay: "立即支付",
  purchaseSuccess: "恭喜你，抢购成功",
  purchaseSuccessNew: "恭喜你，助力成功",
  purchaseError: "抱歉，抢购失败，请刷新页面重试",
};
// 项目详情
const projectDetails = {
  text: "确保持仓超过[*][**]",
  timelimitPic: "限时价",
  subscriptionLimit: "抢购额",
  subscriptionLimitNew: "助力额",
  preheat: "预热",
  supportAbort: "保价截止",
  unlockAbort: "发放时间",
  projectIntroduction: "项目介绍",
  projectRole: "活动规则",
  rule: "抢购规则",
  ruleNew: "助力规则",
};
// 抢购结束
const purchaseOver = {
  haveSubscribed: "已抢购额度",
  schedule: "当前进度",
  Stime: "开始抢购时间",
  StimeNew: "开始助力时间",
  Etime: "结束抢购时间",
  EtimeNew: "结束助力时间",
  successText: "此项目筹款额度 [*] BAT，实际筹款达到筹款目标，筹款 成功！",
  success: "成功",
};
// 我的抢购
const myPurchase = {
  endUnlock: "最后一轮抢购结束解锁",
  endUnlock2: "最后一轮抢购结束发放",
  LText: "保价期内每日解锁",
  WText: "保价期外每日解锁",
  unlockend: "已解锁",
  record: "抢购详情",
  myPurchaseName: "我参与的项目",
};

//mHeader
const mHeader = {
  sy: "首页",
  ksjy: "快速交易",
  zyjy: "专业交易",
  c2c: "C2C交易",
  otc: "OTC交易",
  zczx: "资产中心",
  xwgg: "新闻公告",
  xwgg1: "公告",
  lc: "BiKing Earn",
  gxlc: "高息理财",
  dxjh: "FansUp!",
  fbjy: "买币",
  dl: "登录",
  zc: "注册",
  jtzw: "简体中文",
  ftzw: "繁体中文",
  english: "English",
  kr: "한국어",
  qgms: "抢购秒杀",
  xsjy: "潜力交易",
  // 剩下的国际化
  zczgz: "资产总估值",
  yhzx: "用户中心",
  wdgl: "委单管理",
  tc: "退出账户",
  dltq: "低流通区",
  sdgm: "闪电购买",

  // app down
  appdown: "APP下载",
  appdown1: "下载",
  biking: "BiKing APP",
  gfqb: "官方钱包",
  xzbyapp: "下载BiKing APP",
  xzbyapp2: "下载BiKing APP",
  smewm: "扫描二维码",
  xzhyqb: "下载HyperPay钱包",
  xzhyqb2: "下载HyperPay钱包",
  bbjy: "币币交易",
  hyjy: "永续合约", //"合约交易",
  eftjy: "ETF交易",
  byb: "赚币",
  newPos: "HBT矿池",
  HyperPay: "HyperPay赚币",
  hqlc: "POS挖矿",
  newlc: "赚币",

  // 新header
  dd: "订单",
  zichan: "资产",
  xxzx: "消息中心",
  zhyaq: "账户&安全",
  sfyz: "身份验证",
  wdvip: "我的VIP",
  apigl: "API管理",
  hdzx: "活动中心",
  wdhb: "我的红包",
  flzx: "福利中心",
  bitloan: "币贷宝",
  ggjy: "杠杆交易",
  hyxy: "学院",
  flhd: "福利活动",
  bitWin: "BiKing宝",
};
//progress
const mProgress = {
  dqjd: "当前进度",
  yjs: "已解锁",
};

//res
const res = {
  //抢购错误提示
  seckill_project_000: "系统异常",
  seckill_project_001: "无可用项目",
  seckill_project_002: "项目信息不存在",
  // 用户信息错误提示
  seckill_userInfo_001: "用户不存在",
  //i18n错误提示
  i18n_no_table_001: "系统繁忙",
  //抢购记录
  seckill_record_1: "支付失败",
  //7日持仓规则
  seckill_7days_1: "当前项目下，未查询到持仓规则",
  //钱包相关
  seckill_wallet_1: "系统繁忙",
  seckill_wallet_2: "钱包余额不足",
  seckill_wallet_3: "支付失败",
  //项目统计
  seckill_record_count_1: "数据错误",
  seckill_record_count_2: "支付失败",
  seckill_record_count_3: "支付失败",
  //项目轮次
  seckill_rounds_1: "系统繁忙",
  seckill_rounds_2: "当前项目中,未查询到处于抢购中的轮次",
  seckill_rounds_3: "当前项目中,未查询到轮次信息",
  seckill_rounds_4: "系统繁忙",
  seckill_rounds_5: "当前项目中,未查询到指定轮次信息",
  //项目信息
  seckill_pro_1: "未查询到项目信息",
  seckill_pro_2: "抢购额度小于最小购买数量",
  seckill_pro_4: "系统繁忙",
  seckill_pro_5: "项目处于非上架状态",
  //支付
  seckill_pay_1: "系统繁忙",
  seckill_pay_2: "系统繁忙",
  seckill_pay_3: "未查询到项目信息",
  seckill_pay_4: "抢购额度小于最小购买数量",
  seckill_pay_5: "抢购额度超过本轮剩余额度",
  seckill_pay_6: "没有抢购额度",
  seckill_pay_7: "购买额度大于抢购额度",
  seckill_pay_8: "系统繁忙",
  seckill_pay_9: "交易密码错误",
  seckill_pay_10: "支付失败,请重新购买",
  seckill_pay_11: "支付失败,请重新购买",
  seckill_pay_12: "用户信息错误",
  seckill_pay_13: "支付失败",
  seckill_pay_14: "交易密码错误",
  seckill_pay_15: "系统繁忙",
  seckill_pay_16: "已抢完",
  seckill_pay_17: "抱歉,当前排队抢购人数太多,请您重新尝试",
  seckill_pay_18: "本轮已抢",
  seckill_pay_19: "本轮已抢完",
  seckill_pay_20: "请先登录",
  seckill_pay_21: "请先完成实名认证",
  seckill_pay_22: "该项目仅限中国大陆KYC用户抢购",
  seckill_pay_23: "该项目仅限非中国大陆KYC用户抢购",
  seckill_pay_24: "交易密码错误次数超限,请稍后再试",
  seckill_hold_1: "您持有的[*]数量未达参与条件，请购买后再来参与",
  // 问卷调查
  seckill_survey_submited: "您已提交过此问卷",
  seckill_survey_error: "问卷信息处理出错",
  seckill_survey_info: "当前项目下,未查询到该问卷信息",
};

const addContent = {
  hdjshy:'距离活动结束还有',
  qgsj: "抢购时间",
  qgsjNew: "助力时间",
  gz: "规则",
  zdjg: "最低价格",
  sq: "收起",
  qgms: "抢购秒杀",
  rgxm: "参与项目",
  bled: "本轮额度",
  dqjd: "当前进度",
  yjs: "已解锁",
  yff: "已发放",
  qbcc: "保持仓",
  cg: "超过",
  jxmks: "据 项 目 开 始 还 剩",
  ycgrg: "已成功抢购",
  cgrg: "成功抢购",
  xmed: "项目额度",
  cxmck: "此项目筹款额度",
  ckmb: "实际筹款达到筹款目标",
  ck: "筹款",
  ckxq: "查看详情",
  kqed: "可抢额度",
  zhcc: "账户持仓",
  jjks: "抢购即将开始",
  mmsz: "完成账户交易密码设置",
  qsz: "去设置",
  qbye: "确保账户中[*]的余额大于[**]",
  zjcz: "确保持仓大于[*] [**]（最低购买量）",
  jgdb: "价格担保，绝不破发",
  jgyh: "VIP返利，价格优惠",
  bwbj: "独家法币本位保价",
  bj: "[*]天保价，绝不破发",
  sybj: "[*]%收益，承诺保价",
  zk: "VIP折扣，抢到赚到",
  r: "人",
  lsxm: "历史项目",
  // bpf: "15天不破发，能上不能下",
  bpf: "社区助力，海量福利热浪来袭",
  // syybz: "收益有保障，发行有让利",
  syybz: "参与低门槛，有福利大家享",
  // hg: "回馈VIP，抢购大折扣",
  hg: "成为VIP会员，尊享更多福利",
  zgkx: "最高可享[*] [**]减免",
  vip_zgkx: "VIP等级越高，抢购总价的折扣越多。最高VIP6可享受[*][**]优惠",
  vip_zgkxNew: "VIP等级越高，助力总额的折扣越多。最高VIP6可享受[*][**]优惠",
  blsysj: "本轮剩余时间",
  blqbqw: "本轮全部抢完",
  xyl: "下一轮",
  zskq: "准时开抢",
  bljshs: "本轮抢购结束还剩",
  zqyc: "每轮只能抢购一次，请下一轮再来抢购哦！",
  zxkf: "您没有参与本次活动的权限 详询客服",
  zqycNew: "每轮只能助力一次，请下一轮再来助力哦！",
  wed: "该项目您的可抢额度为0，请关注下一个项目",
  wedNew: "该项目您的可助力额度为0，请关注下一个项目",
  zsqg: "最少抢购额度[*][**]，请加仓后抢购",
  srmm: "请输入交易密码",
  smrz: "请先完成KYC实名认证",
  qszjymm: "请先去设置交易密码",
  wenjuandiaocha: "您需要先完成调查问卷，才能参加本次活动。",
  scqgms: "BiKing粉丝狂欢节",
  // scqgms: "首创保价模式",
  // hxyh: "限时保底收益，VIP更多让利",
  hxyh: "助力BiKing社区，花样福利享不停",
  zsqged: "最少抢购额度[*] [**]",
  zsqgedNew: "最少助力额度[*] [**]",
  wmtj: "您持有的 [**] 数量未达参与条件，请购买后再来参与",
  qjchqg: "请加仓后抢购",
  qjchqgNew: "请加仓后助力",
  rgjg: "抢购价格",
  qqg: "抢折扣",
  wdqgjl: "我的参与记录",
  ckxmxq: "查看项目详情",
  t: "天",
  yr: "[*]月[**]日",
  yrz: "第[*]轮预热中",
  qgz: "第[*]轮抢购中",
  djlyjs: "第[*]轮已结束",
  dj: "VIP等级",
  xszk: "折扣比例",
  jgzked: "参与折扣额度",
  zked: "折扣额度",
  edw: "额度外按正常价格支付",
  qbcczd: "确保持仓大于1000CWT（最低购买量）",
  qrrjcc: "7日日均持仓量",
  jlblks: "距离本轮开抢",
  jlbljs: "距离本轮结束",
  zgkqed: "最高可抢额度",
  zgkzf: "最高可支付",
  cggmsl: "您填写的购买数量超过了您的购买数量限制",
  bzzfzxgm: "当前持仓不足支付最小购买量",
  bqzdqg: "抢购最低额度为 [*] [**]",
  zlzcLower:
    "助力最低额度为[*]，最高额度为[**]。活动结束后助力所得代币将于5个工作日内发放至您的账户中。",
  zgqged: "最高额度为 [*] [**]",
  yzbz: "优质币种限时粉丝专属折扣",
  xszkj: "限时折扣价",
  zlbxsq: "主流币限时抢",
  wks: "未开始",
  jxz: "进行中",
  qgsl: "抢购数量",
  wcydxm: "我参与的项目",
  bjq: "报价期",
  hgq: "回购期",
  qzk: "抢折扣",
  qxzl: "抢先助力赢代币",
  ds: "助力上限",
  dhbl: "兑换比例",
  jicj: "基础价",
  jiagzd: "最终价格在抢购开始前3小时内确定",
  zdyh: "最大优惠",
};

const hyy = {
  bkt: "不开通",
  wqdkt: "我确定开通",
  kt12: "1.	您在参与之前务必详尽地了解数字货币合约交易的基本知识和相关风险以及参与衍生品交易所有关的业务规则等",
  kt13: "2.	本风险提示书上述风险事项仅为列举性质，未能详尽的列明有关数字资产衍生品交易的所有风险因素，投资者参与数字资产衍生品交易投资前，还应该认真对其它可能存在风险因素有所了解和掌握。",
  kt14: "3.	我们诚挚的希望和建议投资者，从风险承受能力等自身实际情况出发，审慎的决定是否参与此合约交易，合理地配置自己的数字资产。",
  kt0: "亲爱的用户：",
  kt1: "您尚未开通合约账户及合约交易权限，请您仔细阅读以下内容以后再决定是否开通：",
  kt2: "一、	您在合约市场进行交易，假如市场价格走势对您不利导致您的仓位保证金不足时，BiKing永续合约会按照系统约定对您的仓位进行强平委托并披露强平明细。",
  kt3: "二、	您必须认真阅读并遵守BiKing永续合约的业务规则，了解合约的机制和运行原理，了解市场的各种风险。",
  kt4: "四、	BiKing永续合约接入的是合约交易系统，用户仓位的盈亏随合约行情的波动而变化，当亏损较大时，亦会在合约交易系统中发生爆仓。请用户您及时根据合约行情自行决定自己的交易行为，自负盈亏，据此，BiKing不承担任何推定或者既定的保证责任。",
  kt5: "五、	在某些极端的市场情况下，您可能会难以或无法将持有的未平仓合约平仓。例如，当你的盈利在整个合约市场中有效杠杆PnL中排位第一，且对手盘在保险基金不足以垫付其穿仓损失的情况下。",
  kt6: "六、	数字资产衍生品交易可能面临一定法域内的政策监管风险，您在交易之前需在了解交易地域的政策监管背景的前提下审慎做出判断。由于相关国家及地区法律、法规、政策的变化、合约交易所交易规则的修改、紧急措施的出台等原因，BiKing会提前披露声明，您持有的未平仓合约可能无法继续持有，但保证金和盈利的结余仍会兑现",
  kt7: "七、	由于非平台方所能控制的原因，例如：地震、水灾、火灾等不可抗力因素或者计算机系统、通讯系统故障等，可能造成您的指令无法成交或者无法全部成交，由此导致的损失可能会由您自己承担。",
  kt8: "八、	 “套期保值”交易同投机交易一样，同样面临价格波动引起的风险。",
  kta9: "九、	如果您没有进行实名认证或者未绑定Google验证，或者将账号借给非本人操作，将可能会影响您的合约保证金的安全性",
  kta10:"三、 在某些极端的市场情况下，您可能会难以或无法将持有的未平仓合约平仓。例如，当你的盈利在整个合约市场中有效杠杆PnL中排位第一，且对手盘在保险基金不足以垫付其穿仓损失的情况下。",
  kt9: "我已仔细阅读，并愿意承担风险",
  kt10: "开通合约账号及合约交易权限",
  zjhz: "资金划转",
  ljhz: "立即划转",
  qx: "取消划转",
  khz: "可划转",
  qxz: "请选择",
  bz: "币种",
  c: "从",
  zz: "转至",
  sl: "数量",
  qb: "全部",
  ktcg: "开通成功",
  ktsb: "开通失败",
  hzcg: "划转成功",
  hzsb: "划转失败",
  wyyd: "", //未勾选已经阅读提示文案
  tc: "退出",
  warning1: "请选择币种",
  warning2: "转出账户不能为空",
  warning3: "转入账户不能为空",
  warning4: "请输入不大于可转数量的数字",
  gb: "关闭",
  openSuccess: "您已开通合约交易",
  openSuccessTip: "请划转资金到合约账户",
  warning5: "最大保留4位小数",
  not_get_nm: "抱歉，泥码活动已发放结束，本次划转未能获得泥码",
};

const trading = {
  gflj: '官方链接',
  gw: '官网',
  qkllq: '区块浏览器',
  scfxsj: '首次发行时间',
  fxzl: '发行总量',
  ltzl: '流通总量',
  jy: '交易',
  sj: '市价',
  tbxx: '图表信息',
  bzgk: '币种概况',
  ddb: '订单表',
  zxcj: '最新成交',

  reload: "刷新",
  socketError: "网络错误，请",
  noData: "暂无数据",
  entrustorder: "盘口",
  prices: "价格",
  quantity: "数量",
  grandtotal: "累计",
  transamount: "交易额",
  time: "时间",
  available: "可用",
  limitorder: "限价",
  plancommission: "计划委托",
  currentcommission: "委托",
  historycommission: "历史委托",
  completecommission: "成交委托",
  funds: '资金',
  hidetrading: "隐藏其他交易对",
  morecurrentcommission: "更多当前委托",
  morehistorycommission: "更多历史委托",
  moredocommission: "更多成交委托",
  realtimetrans: "实时成交",
  myassets: "我的资产",
  detail: "详情",
  buyin: "买入",
  sellout: "卖出",
  login: "登录",
  transfer: "划转",
  recharge: "充值",
  withdrawal: "买币",
  quickpurchase: "法币快捷买币",
  default: "默认",
  ordertime: "挂单时间",
  tradingpair: "交易对",
  direction: "方向",
  types: "类型",
  commissionprice: "委托价格",
  commissionnumber: "委托数量",
  dealprice: "成交均价",
  dealnumber: "成交数量",
  triggerprice: "触发价格",
  cancelall: "全部撤单",
  averageprice: "均价",
  totalsum: "合计",
  fixedprice: "限价",
  marketprice: "市价",
  codeExpired: "二维码已失效",
  clickRefresh: "点击刷新",
  QRsuccessfully: "扫码成功",
  loginInApp: "请在APP内确认登录",
  backtoQR: "返回二维码登录",
  loginSuccess: "您已登录成功，biking欢迎您！",
  loadingText: "加载中...",
  searchPlaceholder: "搜索",
  all: "全部",
  currency: "币种",
  price: "最新价",
  market: "涨幅榜",
  increase: "涨幅",
  highestPrice: "最高",
  minimumPrice: "最低",
  turnover: "成交量",
  jydlb: "交易对列表",
  bzjs: "币种介绍",
  currencyTransaction: "币币交易",
  leveragedTransaction: "杠杆交易",
  warning:
    "风险提示： Bitcoin Cash分叉具有极大的不确定性，交易或者投资分叉期货代币具有极大的风险，如果某一条链缺乏矿工的支持，很可能无法存续，持有的相关代币将有归零风险。BiKing不为任何分叉期货代币的价值作出任何承诺！",
  zb: "指标",
  date: "时间",
  UpAnddown: "涨跌",
  amplitude: "振幅",
  0: "分时",
  1: "1分钟",
  5: "5分钟",
  15: "15分钟",
  30: "30分钟",
  60: "1小时",
  240: "4小时",
  3600: "1天",
  10800: "1周",
  dates: "周期：",
  password: "交易密码",
  errorPassword: "请输入正确交易密码",
  worningPassword: "请输入交易密码",
  cancel: "取消",
  sure: "确定",
  canBuy: "可买",
  canCell: "可卖",
  withdraw: "提币",
  otc: "OTC，法币快速入场提现",
  enterPrice: "请输入价格",
  sellingPrice: "卖出价",
  purchasePrice: "买入价",
  salesVolume: "卖出量",
  buyingVolume: "买入量",
  volume: "交易额",
  serviceCharge: "手续费",
  vip: "升级VIP 手续费立享折扣",
  or: "或",
  register: "注册",
  totalPrice: "交易额不能大于",
  amountTip: "请输入正确数量",
  amountTipError: "数量不能大于",

  limitTrading: "限价交易",
  priceReminder: "价格提醒",
  SMSReminder: "短信提醒",
  loginAccount: "登录账户",
  phone: "手机",
  phoneNum: "请输入手机号码",
  phoneTips: "请输入正确手机号码",
  email: "邮箱",
  emailNum: "请输入邮箱",
  emailTips: "﻿请输入正确邮箱",
  aears: "请选择区号",
  passwordError: "请输入正确密码",
  passwordTips: "请输入密码",
  forgetPassword: "忘记密码",
  noAccount: "没有账号",
  goRegister: "立即注册",
  appsys: "APP扫一扫安全登录",
  xzapp: "下载最新APP",
  mmdl: "密码登陆",
  smdl: "扫码登陆",
  google: "谷歌验证器",
  nybd: "您已绑定",
  zqyzm: "请输入正确验证码",
  fsyzm: "发送验证码",
  flv: "费率",
  jz: "净值",
  jzdesc1:
    "看多净值=上个调整时点的净值*[1+3*(现货最新成交价-现货上个调整时点价格)/现货上个调整时点价格*100%]；",
  jzdesc2:
    "看空净值=上个调整时点的净值*[1-3*(现货最新成交价-现货上个调整时点价格)/现货上个调整时点价格*100%]；",
  sbd: "三倍多",
  sbs: "三倍少",
  flvjs:
    'ETF资金费率，是平台每日对杠杆收取相应比例的管理费，来支付基金组合产生的资金费率。管理费会体现在净值变化中，即会以"扣除相应杠杆ETF的价值"的方式呈现，且仅在新加坡时间0点收取，如果不在该时间点持有产品即不会产生费用。',
  mzsm: "免责声明",
  ido: "我已阅读并同意",
  exemption1: "尊敬的客户，您好！",
  exemption2:
    "感谢您登陆并使用BiKing平台（BiKing.ai）提供的公干ETF产品和相关服务（以下简称“ETF产品”）。请你仔细阅读ETF产品说明和如下风险提示，您在阅读后继续使用ETF产品，即视为您已经完全了解并理解ETF产品的风险，能够承担使用ETF产品可能带来的损失，并视为您同意本免责声明的全部内容。请点击阅读ETF产品说明：",
  exemption3: "《杠杆ETF产品FAQ》",
  exemption4: "风险提示：",
  exemption5:
    "1.您购买/出售的价格不应该较单位净值有较大的偏差，不然您会蒙受相应的损失。",
  exemption6: "2.如果方向判断错误，在极端行情下会存在价格趋近于归零的风险。",
  exemption7:
    "BiKing平台在此郑重的提醒您，因上述风险导致的损失或责任，均由您自行承担，BiKing平台对此不承担任何责任。本免责声明与BiKing平台内的其他协议、声明、规则等一起，构成BiKing平台与您就BiKing平台的服务和产品所达成的全部合意。",
  bzjs1: "1、“3L”表示标的交易对价格上涨1%，该产品净值上涨3%",
  bzjs2: "2、“3S”表示标的交易对价格下跌1%，该产品净值上涨3%",
  bzjs3: "3、净值正常每天0点进行调整，极端行情会在盘中进行调整",
  bzjs4: "4、每倍杠杆将按天收取相应的管理费用",
  bzjs5:
    "5、交易前请注意查看净值，该产品在极端行情下会存在价格趋近于归零，价格远远偏离净值的风险，请投资者注意控制风险",
  gdjk: "更多详情请查看公告",
  firstTrading: "初次交易前，请先设置交易密码",
  status: "状态",
  status1: "待撮合",
  status2: "未成交",
  status3: "用户撤销",
  status4: "部分成交",
  status5: "完全成交",
  status6: "无效",
  allCancel: "批量撤销全部委单",
  canceld: "撤单",
  cancelsuccess: "全部撤单成功,已撤[*]条委单",
  VIP1: "您的等级VIP",
  VIP2: "更为低廉的交易手续费用，更为优质的交易体验",
  VIP3: "Taker(吃单)：",
  VIP4: "Maker(挂单)：",
  buyAmount: "买入数量不能高于",
  sellAmount: "卖出数量不能高于",
  buyAmountMin: "您的可买余额不足",
  sellAmountMin: "您的可卖余额不足",
};

const common = {
  wan: "万",
  qian: "千",
  yi: "亿",
};
const transferDialog = {
  划转: "划转",
  资金互转: "资金互转",
  币币账户: "币币账户",
  买币账户: "买币账户",
  已冻结: "已冻结",
  合约账户: "合约账户",
  未开通: "未开通",
  杠杆账户: "杠杆账户",
  币贷宝账户: "币贷宝账户",
  从: "从",
  转至: "转至",
  币种: "币种",
  数量: "数量",
  全部: "全部",
  用户未归还借贷的情况下: "用户未归还借贷的情况下，风险率大于200% 的资金可转出",
  可划转: "可划转",
  一阶: "1、一阶",
  累计净划入: "累计净划入",
  可获得: "可获得",
  泥码: "泥码",
  二阶: "2、二阶",
  amountLowTipError: "数量不能小于",
  您尚未完成实名认证: "您尚未完成实名认证",
  余额: "余额",
  立即划转: "立即划转",
  资产划转: "资产划转",
  用于维持现有仓位的保证金: "用于维持现有仓位的保证金",
  归还数量: "归还数量",
  您的币贷宝账户尚未开通: "您的币贷宝账户尚未开通，请先开通",
  请输入正确的数量: "请输入正确的数量",
  划转金额不能为: "划转金额不能为0",
  账户可用余额不足: "账户可用余额不足",
  划转失败: "划转失败",
  划转成功: "划转成功",
  本次划转未能获得泥码: "抱歉，泥码活动已发放结束，本次划转未能获得泥码",
  您只需再向合约账户划转:
    "您只需再向合约账户划转 [*] USDT 便能获得 [**] USDT泥码",
  您向合约账户: "您向合约账户<br/>累计净划转 [*]USDT以上,获得",
  请输入划转数量: "请输入划转数量",
};
export {
  state,
  subheader,
  purchase,
  purchaseCondition,
  historyProject,
  alipay,
  projectDetails,
  purchaseOver,
  myPurchase,
  mHeader,
  res,
  addContent,
  hyy,
  trading,
  common,
  transferDialog,
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js